module.exports = __webpack_public_path__ + "4a9e5cdb5a78d24feecb325a9413f088.pdf";